import { withErrorBoundary } from "@edreamsodigeo/frontend-core";

import PrimeLogoComponent from "~/components/common/PrimeLogo";
import withPrimeContext from "../withPrimeContext";

export default withPrimeContext(
  withErrorBoundary(PrimeLogoComponent, {
    name: "PrimeLogoComponent",
  }),
);
